import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiUnfollowVariables = Types.Exact<{
  accountAddress: Types.Scalars['ID'];
}>;


export type ApiUnfollow = { unfollow: boolean };



export const ApiUnfollowDocument = /*#__PURE__*/ `
    mutation Unfollow($accountAddress: ID!) {
  unfollow(accountAddress: $accountAddress)
}
    `;

export const useUnfollow = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiUnfollow, TError, ApiUnfollowVariables, TContext>) => {
    
    return useMutation<ApiUnfollow, TError, ApiUnfollowVariables, TContext>(
      {
    mutationKey: ['Unfollow'],
    mutationFn: (variables?: ApiUnfollowVariables) => apiFetcher<ApiUnfollow, ApiUnfollowVariables>(ApiUnfollowDocument, variables)(),
    ...options
  }
    )};


useUnfollow.fetcher = (variables: ApiUnfollowVariables, options?: RequestInit['headers']) => apiFetcher<ApiUnfollow, ApiUnfollowVariables>(ApiUnfollowDocument, variables, options);
